// extracted by mini-css-extract-plugin
var _1 = "src-common-Widget-module__frame";
export { _1 as "frame" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"frame\":\"src-common-Widget-module__frame\"}";
        // 1776408147914
        var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  